import Talk from "talkjs";
import { createContext, Dispatch, SetStateAction } from "react";
import { EnterpriseDetails, SubscriptionState, SubscriptionTier, User } from "./proto/api_pb";

export interface EnterpriseType {
  id: string,
  name: string,
  image: string,
  role: string,
  storageLimit: number,
  masteringCount: number
}

export interface UserDetailsContextInterface {
  userName: string;
  fullName: string;
  connectedWallet: string;
  storageUsage: number;
  stripeCustomerId: string;
  subscriptionState: number;
  subscriptionTier: number;
  allUsers: User[];
  featuredUsers: User[];
  hasPaymentMethod: boolean;
  enterprise: EnterpriseType | undefined;
  role: string
  isEnterpriseAccount: boolean
  enterprises: EnterpriseDetails[]
}

export interface S3CredentialsContextInterface {
  awsAccessKeyId: string | undefined;
  awsSecretAccessKey: string | undefined;
  awsSessionToken: string | undefined;
  expiry: number | undefined;
}

export const S3CredentialsContext =
  createContext<S3CredentialsContextInterface>({
    awsAccessKeyId: "",
    awsSecretAccessKey: "",
    awsSessionToken: "",
    expiry: 0,
  });

export const UserDetailsContext = createContext<UserDetailsContextInterface>({
  userName: "",
  fullName: "",
  connectedWallet: "",
  storageUsage: 0,
  stripeCustomerId: "",
  subscriptionState: SubscriptionState.SUBSCRIPTION_STATE_UNSPECIFIED,
  subscriptionTier: SubscriptionTier.SUBSCRIPTION_TIER_UNSPECIFIED,
  allUsers: [],
  featuredUsers: [],
  hasPaymentMethod: false,
  enterprise: undefined,
  role: "",
  isEnterpriseAccount: false,
  enterprises: [],
});

export interface AuthContextInterface {
  userId: string;
}

export const AuthContext = createContext<AuthContextInterface>({
  userId: "",
});

export interface TalkJsContextInterface {
  handleChatClick: () => void;
  setParticipants: React.Dispatch<React.SetStateAction<Talk.User[]>>;
  createConversation: (
    conversationId?: string,
    conversationSubject?: string
  ) => void;
  setAutoCreateChat: React.Dispatch<React.SetStateAction<boolean>>;
  conversationId: string;
  conversationSubject: string;
  setConversationId: Dispatch<SetStateAction<string>>;
  setConversationSubject: Dispatch<SetStateAction<string>>;
  isChatOpen: boolean;
  setIsChatOpen: Dispatch<SetStateAction<boolean>>;
}

export const TalkJsContext = createContext<TalkJsContextInterface>({
  handleChatClick: () => { },
  createConversation: () => { },
  setParticipants: () => { },
  setAutoCreateChat: () => { },
  conversationId: "",
  conversationSubject: "",
  setConversationId: () => { },
  setConversationSubject: () => { },
  isChatOpen: false,
  setIsChatOpen: () => { },
});
